import { useEffect, useState } from "react";
import type { CurrentSeason } from "../models/Explorer";
import type { ExplorerAPI } from "../util/Requests";
import { knownCurrentSeason, loadCurrentSeason } from "../util/season";

/** The page scope's current season; null until the first answer this session. */
export function useCurrentSeason(api: ExplorerAPI): CurrentSeason | null {
  const [current, setCurrent] = useState<CurrentSeason | null>(
    () => knownCurrentSeason(api.scope) ?? null,
  );
  useEffect(() => {
    let live = true;
    loadCurrentSeason(api).then((answer) => {
      if (!live) return;
      setCurrent((prev) =>
        prev?.season === answer.season && prev?.seasonAny === answer.seasonAny
          ? prev
          : answer,
      );
    });
    return () => {
      live = false;
    };
  }, [api]);
  return current;
}
